export const CONFIG = {
  apiUrl: 'https://api.wemust.info',
  dashboard: "customer-app",
  appName: "WeMust",
  appTitle: "WeMust",
  appVersion: "1.0.0",
  REACT_APP_STRIPE_PUBLISHABLE_KEY:
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ,
  env: process.env.REACT_APP_ENV,
  // Add other global configuration values here
};
 